import { mapActions } from 'vuex';

export default {
	methods: {
		...mapActions('application', ['setSectionStatus']),
		validateForm(){
			this.$refs.form.validate( is_valid => {
				this.setSectionStatus(is_valid);
				return is_valid;
			});
		}
	}
}
